import { render, staticRenderFns } from "./scorecard-all-orders.vue?vue&type=template&id=18029486&scoped=true"
import script from "./scorecard-all-orders.vue?vue&type=script&lang=js"
export * from "./scorecard-all-orders.vue?vue&type=script&lang=js"
import style0 from "./scorecard-all-orders.vue?vue&type=style&index=0&id=18029486&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18029486",
  null
  
)

export default component.exports